import { Typography } from '@mui/material';
import { useCallback } from 'react';

import CardSelect from 'src/components/card-select';
import { ScreenContainer, InputScreen } from 'src/components/flow';
import { Input } from 'src/lib/constants';
import {
  stringifyAnswerValue,
  updateQuizAnswerAnalytics,
} from 'src/utils/analytics/utils';
import { getInputLabel } from 'src/utils/inputs/labels';
import { getInputProps } from 'src/utils/inputs/options';
import { InfomarkerIcon } from 'src/components/screens/shared/infomarker-icon';

import type { FlowScreenProps } from './types';
import { useSegmentPageAction } from 'src/utils/analytics/hooks';
import { PageActionName, PageActionType } from 'src/utils/analytics/constants';

const CardDepositScreen: React.FC<FlowScreenProps> = ({
  inputs,
  updateInput,
  pageNumber,
  trackEvent,
  nerdyTip = '',
}) => {
  const trackPageAction = useSegmentPageAction();
  const onChange = useCallback(
    (value: any) => {
      updateInput({ name: Input.CardDeposit, value });
    },
    [updateInput]
  );
  return (
    <ScreenContainer
      nerdyTip={nerdyTip}
      primaryCta={{
        text: 'next',
        isDisabled: inputs[Input.CardDeposit] === undefined,
        onClick: async () => {
          const { eventType, payload } = updateQuizAnswerAnalytics(
            inputs[Input.CardDeposit],
            Input.CardDeposit,
            pageNumber
          );
          trackPageAction({
            actionName: PageActionName.CardDeposit,
            actionType: PageActionType.Select,
            actionInput: stringifyAnswerValue(inputs[Input.CardDeposit]),
          });
          trackEvent(eventType, payload);
        },
      }}
    >
      <InputScreen
        headline={
          <>
            <Typography variant="titleSmall">
              {getInputLabel(Input.CardDeposit, inputs)}
            </Typography>
            {nerdyTip && <InfomarkerIcon />}
          </>
        }
      >
        <CardSelect
          name={Input.CardDeposit}
          onChange={onChange}
          value={inputs[Input.CardDeposit]}
          {...getInputProps(Input.CardDeposit, inputs)}
        />
      </InputScreen>
    </ScreenContainer>
  );
};

export default CardDepositScreen;
